import '../styles/main.scss';

// Import AngularJS dependencies
import 'angular';
import '@uirouter/angularjs';
import 'angular-animate';
import 'angular-sanitize';
import 'angular-bootstrap';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-breadcrumb';
import 'angular-loading-bar';
import 'angular-growl-v2';
import 'ng-table';
import 'ng-file-upload';
import * as ngFlow from 'ng-flow';

window.Flow = ngFlow;

import 'ng-flow';
import 'leaflet';
import 'leaflet-draw';
import 'Leaflet.fullscreen';
import 'ui-select';
import moment from 'moment';
import 'moment/locale/pl';
import 'angular-ui-tree';
import 'angular-ui-tinymce';

import 'tinymce';
import 'tinymce/icons/default';
import 'tinymce/skins/ui/oxide/skin.min.css';
import './app';

// Set moment locale
moment.locale('pl');

// Angular bootstrap
angular.element(document).ready(() => {
    'use strict';

    try {
        angular.bootstrap(document, ['appsoupApp'], {strictDi: true});
    } catch (e) {
        console.error('Bootstrap error (strict DI likely):', e.message);
        console.error('Full stack trace:', e.stack);
    }
});
